/**
 * Created by mark on 10/01/2018.
 */

import React from 'react';
import {Button , FormControl , FormGroup ,  Navbar , NavDropdown , MenuItem , Nav , NavItem , Modal , Row , Col} from 'react-bootstrap';
import Card from './card.js';
import SearchService from '../services/search-service.js';
import Recorder from 'react-recorder'
import ContentService from '../services/content-service.js';
import $ from 'jquery';
import ContentStore from '../store/content-store.js';
import { FormattedMessage } from 'react-intl';

function isDataUrl(s){
    let regex = /^\s*data:([a-z]+\/[a-z]+(;[a-z\-]+\=[a-z\-]+)?)?(;base64)?,[a-z0-9\!\$\&\'\,\(\)\*\+\,\;\=\-\.\_\~\:\@\/\?\%\s]*\s*$/i;

    return !!s.match(regex);
}


export default class ImageUpload extends React.Component {
    constructor(props) {
        super(props);
        this.state = {file: '', imagePreviewUrl: props.imagePreviewUrl || ''};
    }

    _handleSubmit(e) {
        e.preventDefault();
        // TODO: do something with -> this.state.file
        console.log('handle uploading-', this.state.file);
    }

    _handleImageChange(e) {
        e.preventDefault();

        let reader = new FileReader();
        let file = e.target.files[0];

        reader.onloadend = () => {
            this.setState({
                file: file,
                imagePreviewUrl: reader.result
            });
            this.props.onChange(reader.result);
            /*
            var fd = new FormData();
            fd.append('action', 'save');
            fd.append('avatar', file.name);
            fd.append('data',  reader.result);

            $.ajax({
                type: 'POST',
                url: 'http://services.languagenut.localhost/upload/uploadAudio',
                data: fd,
                processData: false,
                contentType: false
            }).done(function(data) {
                console.log(data);
            });
            */
        }

        reader.readAsDataURL(file)
    }



    componentWillReceiveProps(props){
        this.setState({
            imagePreviewUrl: props.imagePreviewUrl || ''
        });
    }

    render() {
        let {imagePreviewUrl} = this.state;
        let $imagePreview = null;
        if (imagePreviewUrl) {
            $imagePreview = (<img className="js--image-preview" src={imagePreviewUrl} />);
        } else {
            $imagePreview = (<div className="js--image-preview"></div>);
        }

        return (
            <div className="previewComponent">
                <div className="box">
                    {$imagePreview}
                </div>
                <span className="btn btn-default btn-block btn-file">
                        <FormattedMessage id={"ui-2220"} defaultMessage={"Content Libary"} /> <input type="file" onChange={(e)=>this._handleImageChange(e)} />
                </span>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/imageUpload.js